import { DeleteOutlined } from '@ant-design/icons';
import { FC, memo } from 'react';
import style from './style.module.css';
import { Popconfirm, Tooltip } from 'antd';

interface ITcDeleteIcon {
  onConfirm: () => void;
  confirmText?: string;
  tooltip?: string;
}

const TcDeleteIcon: FC<ITcDeleteIcon> = ({ onConfirm, confirmText, tooltip }) => {
  return (
    <Tooltip title={tooltip ? tooltip : 'حذف'}>
      <Popconfirm onConfirm={onConfirm} title={confirmText ? confirmText : 'این مورد حذف شود؟'}>
        <span className={`inline ${style['red-icon']}`}>
          <DeleteOutlined className='mx-[5px] text-t-error-color cursor-pointer' />
        </span>
      </Popconfirm>
    </Tooltip>
  );
};

export default memo(TcDeleteIcon);
